@if (state$ | async; as state) {
  <div class="page tax-forms">
    <h1 class="c-h1">{{ 'DOCUMENTS.tax_form.title' | translate }}</h1>

    <myabvv-introduction [introduction]="'DOCUMENTS.tax_form.download_and_print' | translate">
    </myabvv-introduction>

    <!-- Info Section -->
    <div class="tax-forms-info">
      <div class="tax-forms-info__item">
        <div class="tax-forms-info__item-icon">
          <i class="fa fa-calendar-alt"></i>
        </div>
        <p>{{ 'DOCUMENTS.tax_form.info1' | translate }}</p>
      </div>
      <div class="tax-forms-info__item">
        <div class="tax-forms-info__item-icon">
          <i class="fa fa-external-link-alt"></i>
        </div>
        <p>{{ 'DOCUMENTS.tax_form.info2' | translate }}</p>
      </div>
    </div>

    <myabvv-alert [condition]="state.error || downloadError()" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>

    @if (state.loading) {
      <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
    }

    @if (state.data?.length && !state.loading) {
      <section class="tax-forms-section">
        <div class="tax-forms-section__header">
          <div class="tax-forms-section__icon">
            <i class="fa fa-file-invoice"></i>
          </div>
          <h3 class="tax-forms-section__title">{{ 'DOCUMENTS.tax_form.subtitle' | translate }}</h3>
        </div>

        <div class="tax-forms-cards">
          @for (taxForm of state.data; track taxForm) {
            <div class="tax-form-card"
                 [class.is-disabled]="isDownloading()"
                 role="button" tabindex="0"
                 (click)="!isDownloading() && downloadFile(taxForm.taxFormId)"
                 (keyup.enter)="!isDownloading() && downloadFile(taxForm.taxFormId)">

              <!-- Year Badge -->
              <div class="tax-form-card__year">
                {{ taxForm.year }}
              </div>

              <!-- PDF Icon -->
              <div class="tax-form-card__pdf-icon">
                <i class="fa fa-file-pdf"></i>
              </div>

              <!-- Content -->
              <div class="tax-form-card__content">
                <span class="tax-form-card__type">{{ taxForm.taxFormType }}</span>
                <div class="tax-form-card__details">
                  <span class="tax-form-card__id">Nr. {{ taxForm.taxFormId }}</span>
                  @if (getTranslatedData(taxForm.region)) {
                    <span class="tax-form-card__region">
                      <i class="fa fa-map-marker-alt"></i>
                      {{ getTranslatedData(taxForm.region) }}
                    </span>
                  }
                </div>
              </div>

              <!-- Download Button -->
              <div class="tax-form-card__download">
                <i class="fa fa-download"></i>
              </div>
            </div>
          }
        </div>
      </section>
    }

    @if (!state.data?.length && !state.loading && !state.error) {
      <div class="info-card-empty">
        <i class="fa fa-inbox info-card-empty__icon"></i>
        <span>{{ 'DOCUMENTS.tax_form.no_data' | translate }}</span>
      </div>
    }
  </div>
}
